<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout justify-center wrap class="marginTop20px">
    <v-flex xs12 sm10 md10>
      <v-card>
        <v-toolbar dark height="35px" flat class="blue">
          <v-toolbar-title class="body-2 font-weight-bold white--text title">{{title}}</v-toolbar-title>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1 edoFixedHeaderInTable"
          hide-actions
        >
          <template v-slot:items="props">
            <tr v-if="props.item.marker" class="TRrowBlue">
              <td class="text-xs-left font-weight-bold rowBlue blue" colspan="8">älter</td>
            </tr>
            <tr v-if="!props.item.marker">
              <td class="text-xs-left">{{ props.item.name }}</td>
              <td class="text-xs-right">{{ props.item.calories }}</td>
              <td class="text-xs-right">{{ props.item.fat }}</td>
              <td class="text-xs-right">{{ props.item.carbs }}</td>
              <td class="text-xs-right">{{ props.item.protein }}</td>
              <td class="text-xs-right">{{ props.item.iron }}</td>
              <td class="text-xs-right">{{ props.item.datum }}</td>
              <td class="text-xs-right">{{ props.item.change }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Newbox',
  components: {},
  props: ['tableTitle'],
  data () {
    return {
      title: 'xx',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {text: 'CrefoNr', value: 'calories'},
        {text: 'Abschlussart', value: 'fat'},
        {text: 'Rechtskreis', value: 'carbs'},
        {text: 'Jahr', value: 'protein'},
        {text: 'Quelle', value: 'iron'},
        {text: 'Datum', value: 'datum'},
        {text: 'Änderungsgrund', value: 'change'}
      ],
      desserts: [
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2014',
          iron: 'Öffentlich',
          datum: '10.04.2019 17:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'UniCredit S.P.A.',
          calories: 400986445,
          fat: 'Konzernabschluss',
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2014',
          iron: 'Öffentlich',
          datum: '10.04.2019 17:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2014',
          iron: 'Öffentlich',
          datum: '10.04.2019 17:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        },
        {
          name: 'Depfa ACS Bank',
          calories: 400986115,
          fat: 'Konzernabschluss',
          marker: false,
          carbs: 'Bankbilanz IFRS Alt',
          protein: '2011',
          iron: 'Öffentlich',
          datum: '22.04.2019 11:47',
          change: 'Jahresabschluss gelöscht'
        }
      ]
    }
  },
  methods: {},
  mounted () {
    this.title = '' + this.tableTitle
    Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tables/MockTable.vue